import { useState } from 'react';

import useErrorNotifications from './hooks/useErrorNotifications';
import useSuccessNotifications from './hooks/useSuccessNotifications';
import useWarnNotifications from './hooks/useWarnNotifications';
import {
  ErrorProps,
  NotificationElement,
  SuccessProps,
  WarnProps
} from './types';

export * from './types';

type NotificationsProps = SuccessProps & ErrorProps & WarnProps & {
  successTimeout?: number;
};

const useNotifications = ({
  isPending,
  isError,
  warnTitle,
  errorTitle,
  warnMessage,
  successTitle,
  errorMessage,
  successMessage,
  successTimeout
}: NotificationsProps) => {
  const [notifications, setNotifications] = useState(
    [] as NotificationElement[]
  );

  useSuccessNotifications({
    isPending,
    successTitle,
    successMessage,
    notifications,
    timeout: successTimeout,
    setNotifications
  });

  useErrorNotifications({
    isError,
    errorTitle,
    errorMessage,
    notifications,
    setNotifications
  });

  useWarnNotifications({
    warnTitle,
    warnMessage,
    notifications,
    setNotifications
  });

  return { notifications };
};

export default useNotifications;
